var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_8874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99995C0 12.1355 3.36445 15.4999 7.49995 15.4999C11.6355 15.4999 14.9999 12.1355 14.9999 7.99995C14.9999 3.86445 11.6355 0.5 7.49995 0.5C3.36436 0.5 0 3.86445 0 7.99995ZM7.49995 14.1587C4.10403 14.1587 1.34127 11.396 1.34127 7.99995C1.34127 6.54315 1.85078 5.20367 2.69963 4.148L11.3519 12.8003C10.2962 13.6491 8.95685 14.1587 7.49995 14.1587ZM13.6586 7.99995C13.6586 9.45676 13.1491 10.7962 12.3004 11.8519L3.648 3.19963C4.70367 2.35078 6.04315 1.84127 7.49995 1.84127C10.8959 1.84127 13.6586 4.60403 13.6586 7.99995Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_8874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "none",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactive);
export default __webpack_public_path__ + "static/media/deactive.f4616094919a309137b02093ad641576.svg";
export { ForwardRef as ReactComponent };